import jsPDF from "jspdf";
import "jspdf-autotable";

// const b = function toDataURL(url, callback) {
//   console.log("hit----------------------");
//   var xhr = new XMLHttpRequest();
//   xhr.onload = function() {
//     var reader = new FileReader();
//     reader.onloadend = function() {
//       callback(reader.result);
//     };
//     reader.readAsDataURL(xhr.response);
//   };
//   xhr.open("GET", url);
//   xhr.responseType = "blob";
//   xhr.send();
// };

export function generatePdf(storeName, genSettings, objectType, title, data) {
  /**
   * Load Document For printing
   */
  // this.$store.commit("btnLoader", true);

  const record = data.record;
  const tableData = data.tableData;

 // const CurrentTax = 16;

  // const TaxRate = `${CurrentTax} %`;

  // const TaxPct = CurrentTax;

  var doc = new jsPDF({ compress: true });
 // var doc = new jsPDF({ compress: true, orientation: 'p',  format: [148, 210] });

  var objectName = title;

  doc.setFont("Georgia, serif", "bold");
  doc.setFontSize(16);
  var pageWidth =
    doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

  /*
      Constnats
  */
  const textFontSize = 11;
  //const tableTextFontSize = 10;
  /*
  LOGO
*/
  // var img = new Image();
  // img.src = require("@/assets/fairland-header.jpeg");
  // doc.addImage(img, "png", 0, 25, pageWidth - 20, 30);

  doc.text(objectName, pageWidth / 2, 10, "center");
  doc.line(5, 11, pageWidth - 5, 11); // Top Line
  doc.setFontSize(10);

  //   doc.text("Original", pageWidth - 20, 14);

  doc.setFontSize(10);

  /*
-------------------------------------------------------------------------------
              BEGINNING OF CUSTOMER DETAILS AND DOCUMENT DETAILS
 -----------------------------------------------------------------------------
*/

  /**
   * Customer Details
   */
  doc.addFont("Tahoma");
  doc.setFont("Tahoma", "bold");
  doc.setFontSize(16);

  doc.setFontSize(11);

  var img = new Image();

  var tableStartingPoint = null;

  // console.log(genSettings.headerImg, '');

  if (genSettings.headerImg) {
    img.src = genSettings.headerImg;
    doc.addImage(img, "png", 10, 15, pageWidth - 20, 50);

    doc.text("Doc No: " + record.DocNum, 10, 75);
    doc.text("To: " + record.ocrd.Name, 10, 80);

    tableStartingPoint = 85;
  }

  if (!genSettings.headerImg) {
    // check if logo exist
    if (genSettings.logo) {
      img.src = "data:image/jpeg;base64," + genSettings.logo;
      // img.src = genSettings.logo;
      doc.addImage(img, "jpg", 10, 15, 60, 30);

      if (genSettings.PhysicalAddress) {
        doc.text(genSettings.PhysicalAddress, pageWidth - 10, 20, "right");
      }

      if (genSettings.poBox) {
        doc.text(genSettings.poBox, pageWidth - 10, 25, "right");
      }

      if (genSettings.PhoneOne) {
        doc.text(
          "Tel: " + genSettings.PhoneOne,
          pageWidth - 10,
          30,
          "right"
        );
      }

      if (genSettings.CompanyEmail) {
        doc.text(
          "Email: " + genSettings.CompanyEmail,
          pageWidth - 10,
          35,
          "right"
        );
      }

      if (genSettings.Website) {
        doc.text(genSettings.Website, pageWidth - 10, 40, "right");
      }

      if (genSettings.PhoneTwo) {
        doc.text(genSettings.PhoneTwo, pageWidth - 10, 45, "right");
      }

      doc.text("Date: " + record.DocDate, pageWidth - 10, 55, "right");

      doc.line(5, 50, pageWidth - 5, 50); // Top Line

      doc.text("Doc No: " + record.DocNum, 10, 55);
      doc.text("To: " + record.ocrd.Name, 10, 60);

      tableStartingPoint = 65;
    }

    // check if logo does not exist

    if (!genSettings.logo) {
      if (genSettings.CompanyName) {
        doc.text(genSettings.CompanyName, 10, 20);
      }

      doc.setFontSize(11);
      if (genSettings.PhysicalAddress) {
        doc.text(genSettings.PhysicalAddress, 10, 25);
      }

      if (genSettings.poBox) {
        doc.text(genSettings.poBox, 10, 30);
      }

    
      // if (genSettings.PinNo) {
      //   doc.text("P.O BOX : " + genSettings.poBox, pageWidth - 10, 20, "right");
      // }

      if (genSettings.PhoneOne) {
        doc.text(
          genSettings.PhoneOne,
          pageWidth - 10,
          20,
          "right"
        );
      }

      if (genSettings.PhoneTwo) {
        doc.text(
          genSettings.PhoneTwo,
          pageWidth - 10,
          25,
          "right"
        );
      }

      if (genSettings.PinNo) {
        doc.text("PIN: " + genSettings.PinNo, pageWidth - 10, 30, "right");
      }

      doc.line(5, 33, pageWidth - 5, 33); // Top Line

      doc.setFontSize(11);

      doc.text("Customer: " + record.ocrd.Name, 10, 40);
      doc.text("Date: " + record.DocDate, pageWidth - 10, 40, "right");

      if (objectType == 14) {
        doc.text("Invoice No: " + record.DocNum, 10, 45);
      }

      if (objectType == 16) {
        doc.text("Delivery No: " + record.DocNum, 10, 45);
      }


      if (objectType == 30) {
        doc.text("Quote No: " + record.DocNum, 10, 45);
      }

      tableStartingPoint = 55;
    }
  }

  doc.setFontSize(textFontSize);

  function headRowsItemDetails() {
    if(objectType == 14) {
      return [
        {
          Quantity: "QTY",
          Unit: "PKG",
          description: "ITEM",
          Price: "UNIT PRICE",
          total_amount: "AMOUNT",
        },
      ];
    }

    if(objectType == 30) {
      return [
        {
          Quantity: "QTY",
          description: "ITEM",
          Price: "UNIT PRICE",
          total_amount: "AMOUNT",
        },
      ];
    }

    if(objectType == 16) {
      return [
        {
          Quantity: "QTY",
          Unit: "PKG",
          description: "ITEM"
        },
      ];
    }

  }
  


  /*
-------------------------------------------------------------------------------
              BEGINNING OF ITEM DETAILS
 -----------------------------------------------------------------------------
*/
  // const repeatText = " ";
  // const embedText = repeatText.repeat(1800);

  const itemDetails = [];

  if(objectType == 14) {
    for (const note of tableData) {
      //  const i = tableData.indexOf(note);
        const itemDetail = {
          Quantity: note.Quantity.toLocaleString(),
          Unit: note.uomentry.UomName,
          description: note.product.Name,
          Price: note.Price.toLocaleString(),
          total_amount: note.LineTotal.toLocaleString(),
        };
    
        itemDetails.push(itemDetail);
      }
  }

  if(objectType == 30) {
    for (const note of tableData) {
      //  const i = tableData.indexOf(note);
        const itemDetail = {
          Quantity: note.Quantity.toLocaleString(),
          description: note.product.Name,
          Price: note.Price.toLocaleString(),
          total_amount: note.LineTotal.toLocaleString(),
        };
    
        itemDetails.push(itemDetail);
      }
  }

  
  if(objectType == 16) {
    for (const note of tableData) {
      //  const i = tableData.indexOf(note);
        const itemDetail = {
          Quantity: note.Quantity.toLocaleString(),
          Unit: note.uomentry.UomName,
          description: note.product.Name
        };
    
        itemDetails.push(itemDetail);
      }
  }



  // const comTax = 1 + TaxPct / 100;

  // const cTax = TaxPct / 100;

  // const subTotalAmount = (record.DocTotal / 116) * 100;

  // const taxAmount = record.DocTotal - subTotalAmount;

  let formattedTotal = record.DocTotal.toLocaleString('en-US', {maximumFractionDigits: 2, minimumFractionDigits: 2});
  // let formattedTaxAmount = taxAmount.toLocaleString('en-US', {maximumFractionDigits: 2, minimumFractionDigits: 2});
  // let formattedSubTotal = subTotalAmount.toLocaleString('en-US', {maximumFractionDigits: 2, minimumFractionDigits: 2});



  // const subTotal = {
  //   Title: "SUB TOTAL",
  //   total_amount: "KES " + formattedSubTotal,
  // };

  // const taxTotal = {
  //   Title: "VAT",
  //   total_amount: "KES " + formattedTaxAmount,
  // };

  const totalAmount = {
    Title: "TOTAL",
    total_amount: "KES " + formattedTotal,
  };

  const totalsData = [];

  // totalsData.push(subTotal);
  // totalsData.push(taxTotal);
  totalsData.push(totalAmount);

  doc.setLineWidth(3);

  doc.autoTable({
    head: headRowsItemDetails(),
    body: itemDetails,
    theme: "grid",
    headStyles: { fillColor: "#808080" },
    bodyStyles: {
      textColor: "#000000",
      fontSize: 11,
    },
    tableWidth: pageWidth - 10,
    columnStyles: {
      total_amount: {
        halign: "left",
        fontStyle: "bold",
      },
      Price: {
        fontStyle: "bold",
      },
      styles: {
        font: "Tahoma",
        fontSize: 11,
      },
    },

    margin: { left: 5 },
    didDrawPage: function(data) {
      // Footer
      var str = "Page";
      var pageCount = doc.internal.getNumberOfPages();
      let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;
      if (typeof doc.putTotalPages === "function") {
        str = "Page " + pageCurrent + " of " + pageCount;
      }
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      // jsPDF 1.4+ uses getWidth, <1.4 uses .width
      var pageSize = doc.internal.pageSize;
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
      doc.text(str, data.settings.margin.right, pageHeight - 10);
    },

    startY: tableStartingPoint,
  });

  // starting of the totals table
  // function totalsHeader() {
  //   return [
  //     {
  //       Title: "",
  //       total_amount: "",
  //     },
  //   ];
  // }

  if(objectType == 14) {
    doc.autoTable({
      body: totalsData,
      theme: "grid",
      columnStyles: {
        total_amount: {
          halign: "right",
          fontStyle: "bold",
        },
        Title: {
          halign: "right",
          fontStyle: "bold",
        },
        styles: {
          font: "Tahoma",
          fontSize: 11,
        },
      },
      tableWidth: pageWidth / 3,
      margin: { left: pageWidth - 75, right: 40 },
      startY: doc.autoTable.previous.finalY + 60,
    });
  }

  if(objectType == 30) {
    doc.autoTable({
      body: totalsData,
      theme: "grid",
      columnStyles: {
        total_amount: {
          halign: "right",
          fontStyle: "bold",
        },
        Title: {
          halign: "right",
          fontStyle: "bold",
        },
        styles: {
          font: "Tahoma",
          fontSize: 11,
        },
      },
      tableWidth: pageWidth / 3,
      margin: { left: pageWidth - 75, right: 40 },
      startY: doc.autoTable.previous.finalY + 60,
    });
  }

  // doc.line(
  //   5,
  //   doc.autoTable.previous.finalY + 5,
  //   pageWidth - 5,
  //   doc.autoTable.previous.finalY + 5
  // ); 

  /*
-------------------------------------------------------------------------------
              BEGINNING FOOTER ITEM DETAILS
 -----------------------------------------------------------------------------
*/

  var pageSize = doc.internal.pageSize;
  var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

  // function headFooter() {
  //   return [
  //     {
  //       count: "",
  //     },
  //   ];
  // }

  
  doc.setFontSize(8);
  if (genSettings.footerImg) {
    var footerImg = new Image();
    footerImg.src = genSettings.footerImg;
    doc.addImage(footerImg, "png", 0, pageHeight - 70, pageWidth, 70);
  }

  if (!genSettings.footerImg) {

    // if(objectType == 11) {
      doc.setFontSize(3);
  
      // const footerArray = [];
    
      // const footTextString = {
      //   count: genSettings.lpoTerms,
      // };
      // footerArray.push(footTextString);

      doc.setLineWidth(2);
    
      doc.line(5, pageHeight - 55, pageWidth - 5, pageHeight - 55); // Top Line
    
  
 
      // doc.text(
      //   "LPO TERMS",
      //   25,
      //   pageHeight - 55,
      //   "center"
      // );

      doc.setFontSize(6);
  
      // doc.autoTable({
      //   head: headFooter(),
      //   body: footerArray,
      //   theme: "plain",
      //   columnStyles: {
      //     styles: {
      //       font: "Tahoma",
      //       fontSize: 3,
      //     },
      //   },
      //   margin: { left: 10 },
      //   startY: pageHeight - 55,
      // });
     // doc.text("VAT No: ", pageWidth - 10, 40, "right");
     if(objectType == 14) {
      doc.text("TERMS", 10, pageHeight - 50);
      doc.text("ACCOUNTS ARE DUE ON DEMAND", 10, pageHeight - 45);
      doc.text("GOODS ONCE SOLD ARE NOT REFUNDABLE", 10, pageHeight - 41);
      doc.text("ALL DISCREPANCIES FOR QUALITY AND PRICE SHOULD BE REPORTED WITHIN 7 DAYS OF DATE THIS INVOICE", 10, pageHeight - 37);
     }

     if(objectType == 16) {
      doc.text("RECEIVED BY: ________________________________: ", 10, pageHeight - 45);
      doc.text("DATE:________________________________________", 10, pageHeight - 37);
      doc.text("SIGNATURE: __________________________________", 10, pageHeight - 30);
     }

  
    //  doc.line(5, pageHeight - 20, pageWidth - 5, pageHeight - 20);
    // }


    // if(objectType != 11) {
    //   doc.setFontSize(11);
    //   doc.text(
    //     "Accounts are due on demand",
    //     pageWidth / 2,
    //     pageHeight - 25,
    //     "center"
    //   );
    // }
    
  }

  return doc.output("bloburi");
}
